export const METRICS = [{ name: 'avg' }, { name: 'max' }, { name: 'min' }, { name: 'std' }]

export const KEY_RAW_MAPPINGS = 'KEY_RAW_MAPPINGS'

export const CACHE_KEY_MAST_METADATA = 'masts+metadata'

export const BINARY = [{ name: 'Sim' }, { name: 'Não' }]
